module.exports = __webpack_public_path__ + "static/media/IconVotingActive.2d6edc7b.svg";